export enum Fuel {
  GAS = "Gas",
  ELECTRICITY = "Electricity",
}
